import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ConfigureLLM from "src/screens/admin/ConfigureLLM";
import ChatSettings from "src/screens/admin/ChatSettings";
import ManageKnowledgeBase from "src/screens/admin/ManageKnowledgeBase";
import OtherSettings from "src/screens/admin/OtherSettings";
import ComplaintCenter from "src/screens/admin/ComplaintCenter";
import ComplaintDetail from "src/screens/admin/ComplaintDetail";
import UserManagementScreen from "src/screens/admin/UserManagement";
import AdminPricingAndCoupons from "src/screens/admin/PriceManagement";
import SubscriptionManagement from "src/screens/admin/SubscriptionManagement";
import DocumentUploads from "src/screens/admin/DocumentUploads";
import { KnowledgebaseFilesDrawer } from "src/components/KnowledgebaseFilesDrawer";
import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/redux/redux-store/configureStore";
import { useManualDocsUpload } from "src/hooks/useManualKnowledgeBaseDocsUpload";
import { useDispatch } from "react-redux";
import {
  forceModalClose,
  setIsLoading,
  setStudentDataUpdating,
} from "src/redux/redux-store/knowledge-base/knowledgebaseReducer";
import { FileUploadStatus } from "src/interfaces/KnowledgeBase";
import { useBackgroundNotifications } from "src/hooks/useBackgroundNotifications";

const baseRoute = "/admin";

export const adminRoutes = {
  DASHBOARD: `dashboard`,
  USER_MANAGEMENT: `userManagement`,
  CONFIGURE_LLM: `configureLLM`,
  PRICING: `pricing`,
  PAYMENTS: `payments`,
  PAYMENT_HISTORY: `payments/paymentHistory`,
  COMPLAINT_CENTER: `complaintCenter`,
  VIEWCOMPLAIN: `complaintCenter/viewComplaint`,
  OTHER_SETTINGS: `otherSettings`,
  CHAT_SETTINGS: `chatSettings`,
  MANAGE_KNOWLEDGEBASE: `manageKnowledgebase`,
  DOCUMENT_UPLOADS: `documentUploads`,
};

const AdminRoutes = () => {
  const fileBeingParsed = useSelector(
    (state: RootState) => state.knowledgebase.fileBeingParsed
  );
  useEffect(() => {
    if (fileBeingParsed.isBeingParsed) {
      console.log("fileBeingParsed", fileBeingParsed);
    }
  }, [fileBeingParsed.isBeingParsed]);
  const dispatch = useDispatch<AppDispatch>();
  const handleDrawerClose = React.useCallback(() => {
    dispatch(setIsLoading(false));
    dispatch(forceModalClose());
    dispatch(setStudentDataUpdating({
      isUpdating: false,
      info: null,
      processedCount: 0,
      fileId: null,
    }));
    console.log("pressed");
  }, [dispatch]);

  const studentDataUpdating = useSelector(
    (state: RootState) => state.knowledgebase.studentDataUpdating || { isUpdating: false, info: null, processedCount: 0, fileId: null }
  );

  useBackgroundNotifications();

  return (
    <>
      <Routes>
        <Route
          path={adminRoutes.COMPLAINT_CENTER}
          element={<ComplaintCenter />}
        />
        <Route
          path={adminRoutes.USER_MANAGEMENT}
          element={<UserManagementScreen />}
        />
        <Route path={adminRoutes.VIEWCOMPLAIN} element={<ComplaintDetail />} />
        <Route
          path={adminRoutes.PAYMENTS}
          element={<SubscriptionManagement />}
        />
        <Route path={adminRoutes.CONFIGURE_LLM} element={<ConfigureLLM />} />
        <Route
          path={adminRoutes.PRICING}
          element={<AdminPricingAndCoupons />}
        />
        <Route path={adminRoutes.CHAT_SETTINGS} element={<ChatSettings />} />
        <Route
          path={adminRoutes.MANAGE_KNOWLEDGEBASE}
          element={<ManageKnowledgeBase />}
        />
        <Route path={adminRoutes.OTHER_SETTINGS} element={<OtherSettings />} />
        <Route
          path={adminRoutes.DOCUMENT_UPLOADS}
          element={<DocumentUploads />}
        />
        {/* Redirect to the admin dashboard if an unknown admin route is accessed */}
        <Route
          path="/"
          element={<Navigate replace to={adminRoutes.COMPLAINT_CENTER} />}
        />
      </Routes>
      {(fileBeingParsed.isBeingParsed &&
        !fileBeingParsed.isModalBeingForcedClosed) || studentDataUpdating.isUpdating ? (
        <KnowledgebaseFilesDrawer
          files={[
            {
              file: studentDataUpdating.isUpdating ? "Student Data Update in Progress" : fileBeingParsed.fileName,
              status: studentDataUpdating.isUpdating ? `Updated Count: ${studentDataUpdating.processedCount}` : "Uploading...",
              info: studentDataUpdating.isUpdating ? studentDataUpdating.info : undefined,
            } as unknown as FileUploadStatus,
          ]}
          visible={fileBeingParsed.isBeingParsed || studentDataUpdating.isUpdating}
          location="right"
          onPressClose={handleDrawerClose}
        />
      ) : null}
    </>
  );
};

export default AdminRoutes;
